const get = name => window.localStorage.getItem(name);

const set = (name, value) => window.localStorage.setItem(name, value);

const remove = name => window.localStorage.removeItem(name);

export default {
  get,
  set,
  remove
};
